import React from "react";
import { useTranslation } from "react-i18next";
import { fmtMoney } from "../../lib/format";

const BUCKET_ORDER = [
  { key: "0_3",     metric: "aging_0_3",    labelKey: "dashboard.aging_bucket_0_3",     dot: "b03"  },
  { key: "4_7",     metric: "aging_4_7",    labelKey: "dashboard.aging_bucket_4_7",     dot: "b47"  },
  { key: "8_14",    metric: "aging_8_14",   labelKey: "dashboard.aging_bucket_8_14",    dot: "b814" },
  { key: "15_plus", metric: "aging_15_plus",labelKey: "dashboard.aging_bucket_15_plus", dot: "b15"  },
];

export default function DashboardAging({ buckets, onRowClick }) {
  const { t } = useTranslation();
  const totalCount = BUCKET_ORDER.reduce(
    (s, o) => s + (buckets?.[o.key]?.count || 0),
    0,
  );

  if (!totalCount) {
    return (
      <div className="qw-empty" data-testid="aging-empty">
        {t("dashboard.aging_empty")}
      </div>
    );
  }

  return (
    <div className="qw-table-wrap" tabIndex={0} role="region" aria-label={t("dashboard.section_aging")}>
      <table className="qw-table aging" data-testid="dashboard-aging-table">
        <thead>
          <tr>
            <th>{t("dashboard.aging_column_range")}</th>
            <th style={{ textAlign: "right" }}>{t("dashboard.aging_column_count")}</th>
            <th style={{ textAlign: "right" }}>{t("dashboard.aging_column_value")}</th>
          </tr>
        </thead>
        <tbody>
          {BUCKET_ORDER.map((o) => {
            const b = buckets?.[o.key] || { count: 0, value: 0 };
            return (
              <tr
                key={o.key}
                data-testid={`aging-row-${o.key}`}
                tabIndex={0}
                onClick={() => onRowClick(o.metric)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onRowClick(o.metric);
                  }
                }}
              >
                <td>
                  <span className={`swatch ${o.dot}`} />
                  {t(o.labelKey)}
                </td>
                <td className="num">{b.count.toLocaleString("bg-BG")}</td>
                <td className="num">{fmtMoney(b.value, "EUR")}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
